import { render } from "./mped-amortization-distribution-view.vue?vue&type=template&id=12522d34"
import script from "./mped-amortization-distribution-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-amortization-distribution-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/amortization/main-asset/mped-amortization-distribution-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12522d34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12522d34', __exports__)) {
    api.reload('12522d34', __exports__)
  }
  
  module.hot.accept("./mped-amortization-distribution-view.vue?vue&type=template&id=12522d34", () => {
    api.rerender('12522d34', render)
  })

}


export default __exports__